import { useTranslation } from "react-i18next";

interface ErrorScreenProps {
  error?: Error
}

export function ErrorScreen({ error }: ErrorScreenProps) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-8 text-center bg-white">
      <span className="text-6xl mb-4" role="img" aria-label="warning">⚠️</span>
      <h1 className="text-xl font-bold mb-2 text-gray-900">{t("error.title")}</h1>
      <p className="text-gray-500 mb-6 max-w-sm">{t("error.description")}</p>
      <button
        onClick={() => window.location.reload()}
        className="bg-green-600 text-white px-6 py-3 rounded-2xl font-bold hover:bg-green-700 transition"
      >
        {t("error.reload")}
      </button>
      {import.meta.env.DEV && error && (
        <pre className="mt-6 text-xs text-left bg-red-50 p-4 rounded-xl overflow-auto max-w-full text-red-700">
          {error.message}
        </pre>
      )}
    </div>
  );
}
